<div class="relative w-full">
  <button
      class="flex justify-center items-center gap-3 pr-2 border-r border-tone-05 mr-2 md:pr-4 md:mr-4"
      (clickOutside)="closeDropdown()" id="dropdownDefaultButton"
      (click)="toggleDropdown()" type="button">
      <span [class]="'fi fi-'+flag"></span>
      <i class="icon-chevron-up text-tone-07 text-lg"></i>
  </button>

  <div class="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow max-h-[170px] overflow-y-scroll w-full"
      [ngClass]="hideDropdown? 'hidden': 'block'">
      <ul class="py-2 text-sm text-gray-700 " aria-labelledby="dropdownDefaultButton">
          <li *ngFor="let item of countryCodes"
              class="hover:bg-gray-100 hover:cursor-pointer"
              (click)="dropDownSelected(item)">
              <button class="block px-4 py-2"><span [class]="'fi fi-'+item.twoLetterCode?.toLowerCase()"></span></button>
          </li>
      </ul>
  </div>
</div>
